<script setup>
import {computed} from 'vue'

import {usePageEditorStore} from '@/stores/pageEditor'

const pageEditorStore = usePageEditorStore()

const pageContainers = computed(() => pageEditorStore.pageContainers)
const activeSectionId = computed(() => pageEditorStore.activeSectionId)
const sectionData = computed(() => pageEditorStore.pageSectionData?.find(o => o.id === activeSectionId.value))

const pageContainerId = computed({
    get() {
        return sectionData.value?.pageContainerId || ''
    },
    set(newValue) {
        pageEditorStore.saveSectionContainer(newValue)
    }
})
</script>

<template>
    <div>
        <label>Container</label>
        <select v-model="pageContainerId" class="form-select form-select-sm w-auto">
            <option value="" selected disabled>Select&hellip;</option>
            <option v-for="o in pageContainers" :key="o.id" :value="o.id">
                {{ o.title }}
            </option>
        </select>
    </div>
</template>